import { Mutation, VuexModule, Module, Action, getModule } from 'vuex-module-decorators'
import { TCWBaseError } from '@/plugins/TCWBaseError'
import store from '@/store'

/**
 * エラーSTORE
 */
@Module({
  name: 'ErrorStoreModule',
  store,
  namespaced: true,
  dynamic: true
})
export default class ErrorStoreModule extends VuexModule {
  private errorStore: TCWBaseError | false = false

  /****************
   * Mutation
   ****************/
  @Mutation
  private setErrorStore(error: TCWBaseError | false) {
    this.errorStore = error
  }

  /****************
   * Getter
   ****************/
  public get hasError(): boolean {
    return this.errorStore !== false
  }
  public get get(): TCWBaseError | null {
    return this.errorStore ? this.errorStore : null
  }

  /****************
   * Action
   ****************/
  /**
   * 新規データ作成
   */
  @Action({ rawError: true })
  public setError(error: TCWBaseError): void {
    // this.setErrorStore(error);
    this.context.commit('setErrorStore', error)
  }
  /**
   * エラー除去
   */
  @Action({ rawError: true })
  public clear(): void {
    this.setErrorStore(false)
    // this.context.commit("setErrorStore", false);
  }
}

export const errorStore = getModule(ErrorStoreModule)
